import * as React from 'react';

import { ToString } from '../../lib/utils';

class Tooltip extends React.Component<Tooltips.IProps, Tooltips.IState> {
  element = React.createRef<HTMLSpanElement>();

  componentDidMount() {
    if (this.element && this.element.current) {
      $(this.element.current).tooltip();
    }
  }

  render() {
    const { message, containerClassName, children, ...rest } = this.props;

    if (!message && !children) {
      return null;
    }

    return (
      <span ref={this.element} data-tooltip={ToString(message)} className={containerClassName || ''} {...rest}>
        {children}
      </span>
    );
  }
}

export default Tooltip;
